(() => {
 if (customElements.get('luuma-sticky-cart')) return;
 class LuumaStickyCart extends HTMLElement {
  connectedCallback() {
   this.button = this.querySelector('[data-sticky-add]');
   this.price = this.querySelector('[data-sticky-price]');
   this.status = this.querySelector('[data-sticky-status]');
   this.main = document.querySelector('.luuma-main');
   if (!this.main || !this.button) return;
   this.form = this.main.querySelector('product-form form');
   this.original = this.main.querySelector('product-form button[name="add"]');
   if (!this.form || !this.original) return;
   this.onClick = () => {
    this.sync();
    if (this.button.disabled || !this.original.isConnected) return;
    if (this.form.reportValidity()) {
     this.original.click();
     this.main.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
    }
   };
   this.button.addEventListener('click',this.onClick);
   this.observer = new MutationObserver(() => this.sync());
   this.observer.observe(this.main,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
   this.visibility = new IntersectionObserver(entries => {
    const entry = entries[0];
    this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
    document.body.classList.toggle('luuma-has-sticky', !this.hidden);
   },{threshold:0});
   this.visibility.observe(this.original);
   this.sync();
  }
  sync() {
   this.original = this.main?.querySelector('product-form button[name="add"]');
   if (!this.original) return;
   const variantInput = this.form?.querySelector('input[name="id"]');
   this.button.disabled = this.original.disabled || this.original.getAttribute('aria-disabled') === 'true' || !variantInput?.value;
   this.button.textContent = this.original.querySelector('span')?.textContent.trim() || this.original.textContent.trim();
   const activePrice = this.main.querySelector('.price--on-sale .price-item--sale') || this.main.querySelector('.price__regular .price-item--regular');
   const priceContainer = this.main.querySelector('[id^="price-"]');
   this.price.textContent = priceContainer?.classList.contains('hidden') ? '' : activePrice?.textContent.trim() || '';
   this.status.textContent = this.button.disabled ? this.button.textContent : '';
  }
  disconnectedCallback() {
   this.observer?.disconnect(); this.visibility?.disconnect();
   this.button?.removeEventListener('click',this.onClick);
   document.body.classList.remove('luuma-has-sticky');
  }
 }
 customElements.define('luuma-sticky-cart',LuumaStickyCart);
})();